

































import { flatten } from 'lodash';
import glDispopicker from 'gl-uikit/src/components/gl-dispopicker.vue';
import { ACTION_SET_ROUTES_BY_TRIP } from '@/store/modules/tracking';
import { getStaticUrl } from '@/helpers';

export default {
    data() {
        return {
        };
    },
    computed: {
        events(this: any) {
            if (this.$store.state.tracking.routes.events) {
                const events: any[] = Object.values(this.$store.state.tracking.routes.events);
                return flatten(Object.values(events)).filter((item: any) => Boolean(item.address && item.address.position.coordinates.length)).map((item: any) => ({
                    type: item.event_type.name,
                    address: item.address.indirizzo,
                    expected: item.expected_datetime,
                    actual: item.datetime,
                    icon: getStaticUrl('marker_direction.png'), // to do set proper image
                }));
            }

            return [];
        },
    },
    methods: {
        loadTrack(this: any, idTrip: string) {
            this.$store.dispatch(ACTION_SET_ROUTES_BY_TRIP, idTrip);
        },
    },
    components: {
        glDispopicker,
    },
};
